import { Image, Button } from '@belong/ui';
import { STRINGS } from 'post-inspection/constants/strings';

type Props = {
  onClick: () => void;
};

export const PaymentStepperBackButton = ({ onClick }: Props) => (
  <div className="fixed left-xs top-[12px] h-[36px] sm:absolute sm:top-xs">
    <Button onClick={onClick} variant="text">
      <div className="p-xs">
        <Image
          alt={STRINGS['previous-step']}
          className="h-[16px] w-[16px] rotate-180"
          src="icons/icon_navy_forward.svg"
        />
      </div>
    </Button>
  </div>
);
